export const localDev = false

export const filterPath = ['/visitor', '/app/personInfo', '/toLogin','/login']



// WEBPACK FOOTER //
// ./src/utils/constant.js